import { MinutasPronosticoElementAPI } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { client as fetch } from './ClientService'

export interface MinutasPronosticoInterface {
  getMinutasPronostico(): Promise<Commit<MinutasPronosticoElementAPI[]>>
  getLinkDescarga(fecha: string): Promise<Commit<string>>
}

export class MinutasPronosticoService implements MinutasPronosticoInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  resumen: number = this.env.settings.PRONOSTICO_HIDRICO.resumen ? this.env.settings.PRONOSTICO_HIDRICO.resumen : 2;
  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }
  async getMinutasPronostico (): Promise<Commit<MinutasPronosticoElementAPI[]>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/minutas_pronostico_aa`)
      console.log(response)
      return { type: 'MINUTAS_PRONOSTICO_FETCHED', payload: response }
    } catch (e) {
      return { type: 'MINUTAS_PRONOSTICO_ERROR', payload: e }
    }
  }
  async getLinkDescarga (fecha: string): Promise<Commit<string>> {
    const api = `${this.generateAPI(fecha)}`
    return { type: 'MINUTAS_PRONOSTICO_SET_API_DESCARGA', payload: api }
  }
  generateAPI (fecha: string): string {
    const newFecha = fecha.replace(/[- :]/g, '')
    return `${this.apiUrl}/api/minutas_pronostico_aa/${newFecha}`
  }
}
